export function bloquearCamposFormulario () {
  $("select, input[type=date],input[type=checkbox], input, textarea, file").prop('disabled', true);
  $(".k-select, .k-clear-value").hide();
}

export function fecharModal () {

  $("body").on('click', '.fechar-modal', function () {
    $(this).closest('.modal').modal('close');
  });

}



// WEBPACK FOOTER //
// ./src/helpers/Formulario/Formulario.js